<template>
  <div class="form">
    <form v-on:submit.prevent>
      <b-field>
        <b-input
          v-model="query"
          icon="magnify"
          aria-placeholder="Search..."
          placeholder="Search..."
          type="search"
        ></b-input>
      </b-field>
      <SearchQuery
        :searchText="searchButtonText"
        :index="es.index"
        :from="es.from"
        :query="es.query"
        :size="es.size"
        :searched="searched"
        :term="query"
        :page="page"
        v-on:start:search="validateSearch"
      />
    </form>
    <b-message
      title="Warning"
      class="warning"
      v-if="bad.trigger"
      type="is-warning"
    >
      {{ this.bad.termWarningMessage }}
    </b-message>
  </div>
</template>

<script>
import SearchQuery from "@/components/SearchQuery";
import naughtyStrings from "@/assets/blns.json";

export default {
  name: "GoSearchForm",
  data() {
    return {
      bad: {
        term: naughtyStrings,
        termWarningMessage:
          "Sorry, this is a restricted query, please try again.",
        trigger: false
      },
      es: {
        currentPage: 1,
        index: "go",
        from: 0,
        query: {},
        size: 50
      },
      query: "",
      searchButtonText: "Go",
      searched: false
    };
  },
  props: {
    searching: Boolean,
    term: String,
    page: Number
  },
  watch: {
    page() {
      this.pageUpdated();
    },
    searching() {
      this.setQuery();
    }
  },
  components: {
    SearchQuery
  },
  mounted() {
    this.setSearch();
    this.validateSearch();
  },
  methods: {
    pageUpdated() {
      this.$emit("update:page");
      if (this.es.currentPage < this.page) {
        this.nextPage();
      } else {
        this.prevPage();
      }
    },
    nextPage() {
      this.$emit(
        "next",
        ((this.es.currentPage += 1), (this.es.from += this.es.size))
      );
    },
    prevPage() {
      this.$emit(
        "prev",
        ((this.es.currentPage -= 1), (this.es.from -= this.es.size))
      );
    },
    setSearch() {
      this.query = this.$route.query.qt || this.$route.query.q || "";
      this.query.length ? (this.searched = true) : (this.searched = false);
    },
    setQuery() {
      this.es.query = {
        bool: {
          should: {
            multi_match: {
              query: this.query,
              type: "best_fields",
              operator: "and",
              cutoff_frequency: "0.001",
              tie_breaker: "0.3",
              zero_terms_query: "all"
            }
          },
          must_not: [
            {
              multi_match: {
                query: "noindex"
              }
            },
            {
              multi_match: {
                query: "tickets.getty.edu"
              }
            },
            {
              match: {
                url: "*.pdf"
              }
            }
          ]
        }
      };
    },
    search() {
      if (this.bad.trigger === false) {
        this.searched = true;
        this.setQuery();
        this.$emit("queried:terms", {
          term: this.query.term
        });
      }
    },
    validateSearch() {
      if (this.bad.term.includes(this.query)) {
        this.bad.trigger = true;
      } else {
        this.bad.trigger = false;
      }
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  background-color: lighten($grey-lighter, 5%);
  padding: 0.5em 0;
}
.message.is-warning {
  width: 55%;
  margin: 1em auto 0;
}
form {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  .field {
    display: flex;
    margin-bottom: 0 !important;
    width: 50%;
    .control {
      width: 100%;
    }
  }
  #search {
    display: flex;
  }
  .break {
    flex-basis: 100%;
    height: 0;
  }
}
</style>
